const navLinks = {
  services: [
    { href: "/services/ai-strategy", labelKey: "nav.links.aiStrategy" },
    { href: "/services/llm-integration", labelKey: "nav.links.llmIntegration" },
    { href: "/services/mlops", labelKey: "nav.links.mlops" },
    { href: "/services/data-strategy", labelKey: "nav.links.dataStrategy" },
    { href: "/services/ai-chatbot", labelKey: "nav.links.aiChatbot" },
    { href: "/services/computer-vision", labelKey: "nav.links.computerVision" },
  ],
  industries: [
    { href: "/industries/banking", labelKey: "nav.links.banking" },
    { href: "/industries/fintech", labelKey: "nav.links.fintech" },
    { href: "/industries/edtech", labelKey: "nav.links.edtech" },
    { href: "/industries/insurtech", labelKey: "nav.links.insurtech" },
    { href: "/industries/marketing", labelKey: "nav.links.marketing" },
    { href: "/industries/healthcare", labelKey: "nav.links.healthcare" },
    { href: "/industries/manufacturing", labelKey: "nav.links.manufacturing" },
    { href: "/industries/government", labelKey: "nav.links.government" },
  ],
  about: [
    { href: "/portfolio", labelKey: "nav.links.caseStudies" },
    { href: "/about-us", labelKey: "nav.links.ourTeam" },
    { href: "/blog", labelKey: "nav.links.blog" },
    { href: "/contact", labelKey: "nav.links.contactUs" },
  ],
};

export default navLinks;
